var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatThin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2759_4637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 37
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2759_4637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03857 23.4556V5.61732C4.03857 5.27212 4.17504 4.95794 4.44796 4.67476C4.72086 4.39159 5.02671 4.25 5.36551 4.25H24.0423C24.3914 4.25 24.7024 4.38902 24.9753 4.66707C25.2482 4.94512 25.3847 5.26187 25.3847 5.61732V18.2288C25.3847 18.574 25.2482 18.8882 24.9753 19.1713C24.7024 19.4545 24.3914 19.5961 24.0423 19.5961H9.34621L5.07031 23.872C4.87671 24.0656 4.65636 24.1116 4.40926 24.01C4.16214 23.9084 4.03857 23.7236 4.03857 23.4556ZM10.6885 26.1729C10.3497 26.1729 10.0413 26.0314 9.76329 25.7482C9.48524 25.465 9.34621 25.1508 9.34621 24.8057V22.2307H27.5433L28.0193 22.7067V9.49996H30.6346C30.9734 9.49996 31.2792 9.64155 31.5521 9.92472C31.8251 10.2079 31.9615 10.5272 31.9615 10.8826V30.0088C31.9615 30.2823 31.838 30.4698 31.5908 30.5714C31.3437 30.6731 31.1234 30.6271 30.9298 30.4335L26.6693 26.1729H10.6885ZM23.5001 6.13456H5.92314V18.7501L6.9617 17.7115H23.5001V6.13456Z",
    fill: "url(#paint0_linear_2759_4637)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2759_4637",
    x1: 34.648,
    y1: 27.6019,
    x2: 7.00251,
    y2: 32.9307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7030A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#D96380"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF934E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatThin);
export default __webpack_public_path__ + "static/media/chat-thin.cb22dda0025c207c9d86d9e6742f491a.svg";
export { ForwardRef as ReactComponent };